import React, { useState } from "react";
import { Button, Modal, Space, Spin } from "antd";
import { FaFileDownload, FaEye } from "react-icons/fa";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import moment from "moment";

// Import your PDF template
import formTemplate from "../../../../assets/Joining_Kit_FORM.pdf";

const PdfJoiningKit = ({formData}) => {
  console.log("formData-kit-pdf",formData)
  const [pdfUrl, setPdfUrl] = useState(null);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const drawCheckmark = (page, x, y) => {
    page.drawLine({
      start: { x: x - 3, y: y + 1 },
      end: { x: x, y: y - 2 },
      thickness: 1.2,
      color: rgb(0, 0, 0),
    });
    page.drawLine({
      start: { x: x, y: y - 2 },
      end: { x: x + 5, y: y + 3 },
      thickness: 1.2,
      color: rgb(0, 0, 0),
    });
  };

  const CHECKMARK_POSITIONS = {
    maritalStatus: {
      'MARRIED': { x: 150, y: 478 },
      'UNMARRIED': { x: 203, y: 478 },
      'WIDOW': { x: 255, y: 478 },
      'WIDOWER': { x: 255, y: 478 },
      'DIVORCEE': { x: 255, y: 478 }
    },
    gender: {
      'MALE': { x: 115, y: 505 },
      'FEMALE': { x: 168, y: 505 },
      'OTHER': { x: 223, y: 505 }
    }
  };

  const fillPdfForm = async () => {
    try {
      const existingPdfBytes = await fetch(formTemplate).then(res => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const secondPage = pages[1];
      const page11 = pages[10];
      const page19 = pages[17];
      const page20 = pages[18];
      const page21 = pages[19];
      const page25 = pages[23];
      const form = pdfDoc.getForm();

      const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const helveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      const textOptions = {
        size: 8,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      };

      // SECTION 1: Personal Information
      // Legal Name
      firstPage.drawText(formData.section1?.personalInfo?.legalName?.toUpperCase() || '', {
        x: 78,
        y: 600,
        ...textOptions
      });

      // First Name
      firstPage.drawText(formData.section1?.personalInfo?.firstName?.toUpperCase() || '', {
        x: 205,
        y: 600,
        ...textOptions
      });

      // Middle Name
      firstPage.drawText(formData.section1?.personalInfo?.middleName?.toUpperCase() || '', {
        x: 335,
        y: 600,
        ...textOptions
      });

      // Last Name
      firstPage.drawText(formData.section1?.personalInfo?.lastName?.toUpperCase() || '', {
        x: 445,
        y: 600,
        ...textOptions
      });

      // Father's Name
      firstPage.drawText(formData.section1?.personalInfo?.fatherName?.toUpperCase() || '', {
        x: 150,
        y: 585,
        ...textOptions
      });

      // Joining Date
      if (formData.section1?.personalInfo?.joiningDate) {
        const joinDate = moment(formData.section1.personalInfo.joiningDate);
        if (joinDate.isValid()) {
          firstPage.drawText(joinDate.format('DD'), {
            x: 240,
            y: 560,
            ...textOptions
          });
          firstPage.drawText('/', {
            x: 250,
            y: 560,
            ...textOptions
          });
          firstPage.drawText(joinDate.format('MM'), {
            x: 255,
            y: 560,
            ...textOptions
          });
          firstPage.drawText('/', {
            x: 265,
            y: 560,
            ...textOptions
          });
          firstPage.drawText(joinDate.format('YYYY'), {
            x: 270,
            y: 560,
            ...textOptions
          });
        }
      }

      // Education Info
      if (formData.section2?.educationInfo && Array.isArray(formData.section2.educationInfo)) {
        formData.section2.educationInfo.forEach((edu) => {
          let y;

          if (edu.examination === "X") {
            y = 475;
          } else if (edu.examination === "XII") {
            y = 460;
          } else if (edu.examination === "Graduation") {
            y = 445;
          } else if (edu.examination === "Post Graduation") {
            y = 430;
          } else if (edu.examination === "Any Diploma") {
            y = 415;
          }

          if (y !== undefined) {
            firstPage.drawText((edu.degree || '').toUpperCase(), {
              x: 190,
              y,
              ...textOptions
            });
            firstPage.drawText((edu.institution || '').toUpperCase(), {
              x: 295,
              y,
              ...textOptions
            });
            firstPage.drawText((edu.board || '').toUpperCase(), {
              x: 385,
              y,
              ...textOptions
            });
            firstPage.drawText((edu.year || '').toUpperCase(), {
              x: 490,
              y,
              ...textOptions
            });
          }
        });
      }

      // Work Experience
      firstPage.drawText(formData.section3?.workExperience?.totalExperience?.toUpperCase() || '', {
        x: 190,
        y: 367,
        ...textOptions
      });

      if (formData.section3?.experiences && Array.isArray(formData.section3.experiences)) {
        const maxEntries = 6;
        const yPositions = [315, 300, 285, 270, 255, 240];

        formData.section3.experiences.slice(0, maxEntries).forEach((exp, index) => {
          const y = yPositions[index];

          firstPage.drawText((exp.period || '').toUpperCase(), {
            x: 90,
            y,
            ...textOptions
          });

          firstPage.drawText((exp.company || '').toUpperCase(), {
            x: 200,
            y,
            ...textOptions
          });

          firstPage.drawText((exp.designation || '').toUpperCase(), {
            x: 283,
            y,
            ...textOptions
          });

          firstPage.drawText((exp.jobNature || '').toUpperCase(), {
            x: 390,
            y,
            ...textOptions
          });

          firstPage.drawText((exp.reason || '').toUpperCase(), {
            x: 490,
            y,
            ...textOptions
          });
        });
      }

      // Address Information
      const presentAddress = formData.section1?.addressInfo?.currentAddress?.cAddress?.toUpperCase() || '';
      firstPage.drawText(presentAddress, {
        x: 150,
        y: 175,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const presentAddressCity = formData.section1?.addressInfo?.currentAddress?.cCity?.toUpperCase() || '';
      firstPage.drawText(presentAddressCity, {
        x: 95,
        y: 140,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const presentAddressDist = formData.section1?.addressInfo?.currentAddress?.cDistrict?.toUpperCase() || '';
      firstPage.drawText(presentAddressDist, {
        x: 200,
        y: 140,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const presentAddressState = formData.section1?.addressInfo?.currentAddress?.cState?.toUpperCase() || '';
      firstPage.drawText(presentAddressState, {
        x: 100,
        y: 115,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const presentAddressPincode = formData.section1?.addressInfo?.currentAddress?.cPincode?.toUpperCase() || '';
      firstPage.drawText(presentAddressPincode, {
        x: 230,
        y: 115,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const permanentAddress = formData.section1?.addressInfo?.permanentAddress?.pAddress?.toUpperCase() || '';
      firstPage.drawText(permanentAddress, {
        x: 395,
        y: 175,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const permanentAddressCity = formData.section1?.addressInfo?.permanentAddress?.pCity?.toUpperCase() || '';
      firstPage.drawText(permanentAddressCity, {
        x: 325,
        y: 140,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const permanentAddressDist = formData.section1?.addressInfo?.permanentAddress?.pDistrict?.toUpperCase() || '';
      firstPage.drawText(permanentAddressDist, {
        x: 430,
        y: 140,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const permanentAddressState = formData.section1?.addressInfo?.permanentAddress?.pState?.toUpperCase() || '';
      firstPage.drawText(permanentAddressState, {
        x: 330,
        y: 115,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      const permanentAddressPincode = formData.section1?.addressInfo?.permanentAddress?.pPincode?.toUpperCase() || '';
      firstPage.drawText(permanentAddressPincode, {
        x: 460,
        y: 115,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      // Gender
      if (formData.section1?.personalInfo?.gender) {
        const gender = formData.section1.personalInfo.gender.toUpperCase();
        const position = CHECKMARK_POSITIONS.gender[gender];
        if (position) {
          drawCheckmark(secondPage, position.x, position.y);
        }
      }

      // Marital Status
      if (formData.section1?.personalInfo?.maritalStatus) {
        const status = formData.section1.personalInfo.maritalStatus.toUpperCase();
        const position = CHECKMARK_POSITIONS.maritalStatus[status];
        if (position) {
          drawCheckmark(secondPage, position.x, position.y);
        }
      }

      // Marriage Anniversary
      if (formData.section1?.personalInfo?.marriageAnniversary) {
        const anniDate = moment(formData.section1.personalInfo.marriageAnniversary);
        if (anniDate.isValid()) {
          secondPage.drawText(anniDate.format('DD'), {
            x: 210,
            y: 448,
            ...textOptions
          });
          secondPage.drawText('/', {
            x: 220,
            y: 448,
            ...textOptions
          });
          secondPage.drawText(anniDate.format('MM'), {
            x: 225,
            y: 448,
            ...textOptions
          });
          secondPage.drawText('/', {
            x: 235,
            y: 448,
            ...textOptions
          });
          secondPage.drawText(anniDate.format('YYYY'), {
            x: 240,
            y: 448,
            ...textOptions
          });
        }
      }

      // Actual DOB
      if (formData.section1?.personalInfo?.actualDob) {
        const dob = moment(formData.section1.personalInfo.actualDob);
        if (dob.isValid()) {
          secondPage.drawText(dob.format('DD'), {
            x: 240,
            y: 393,
            ...textOptions
          });
          secondPage.drawText('/', {
            x: 250,
            y: 393,
            ...textOptions
          });
          secondPage.drawText(dob.format('MM'), {
            x: 255,
            y: 393,
            ...textOptions
          });
          secondPage.drawText('/', {
            x: 265,
            y: 393,
            ...textOptions
          });
          secondPage.drawText(dob.format('YYYY'), {
            x: 270,
            y: 393,
            ...textOptions
          });
        }
      }

      // Blood Group
      secondPage.drawText(formData.section1?.personalInfo?.bloodGroup || '', {
        x: 140,
        y: 353,
        ...textOptions
      });

      // Contact Number
      secondPage.drawText(formData.section1?.personalInfo?.contactNumber || '', {
        x: 140,
        y: 325,
        ...textOptions
      });

      // Email
      secondPage.drawText(formData.section1?.personalInfo?.emailId || '', {
        x: 120,
        y: 273,
        ...textOptions
      });

      // PAN Number
      secondPage.drawText(formData.section1?.personalInfo?.panNumber || '', {
        x: 130,
        y: 595,
        ...textOptions
      });

      // Bank Details
      secondPage.drawText(formData.section1?.bankDetails?.bankName?.toUpperCase() || '', {
        x: 140,
        y: 570,
        ...textOptions
      });

      // Fixed: Changed accountNumber to bankAccountNumber
      secondPage.drawText(formData.section1?.bankDetails?.bankAccountNumber || '', {
        x: 145,
        y: 555,
        ...textOptions
      });

      secondPage.drawText(formData.section1?.bankDetails?.ifscCode?.toUpperCase() || '', {
        x: 140,
        y: 542,
        ...textOptions
      });

      // Family Information
      // Spouse Name
      secondPage.drawText(formData.section4?.familyInfo?.spouseName?.toUpperCase() || '', {
        x: 180,
        y: 655,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0)
      });

      // Spouse DOB
      if (formData.section4?.familyInfo?.spouseDob) {
        const spouseDob = moment(formData.section4.familyInfo.spouseDob);
        if (spouseDob.isValid()) {
          secondPage.drawText(spouseDob.format('DD-MM-YYYY'), {
            x: 440,
            y: 655,
            size: 7,
            font: helveticaFont,
            color: rgb(0, 0, 0)
          });
        }
      }

      // Children
      if (formData.section4?.familyInfo?.children && Array.isArray(formData.section4.familyInfo.children)) {
        formData.section4.familyInfo.children.forEach((child, index) => {
          if (index >= 3) return; // Only handle first 3 children

          const yPos = 640 - (index * 15);

          // Child Name
          secondPage.drawText(child.name?.toUpperCase() || '', {
            x: 180,
            y: yPos,
            size: 7,
            font: helveticaFont,
            color: rgb(0, 0, 0)
          });

          // Child DOB
          if (child.dob) {
            const childDob = moment(child.dob);
            if (childDob.isValid()) {
              secondPage.drawText(childDob.format('DD-MM-YYYY'), {
                x: 440,
                y: yPos,
                size: 7,
                font: helveticaFont,
                color: rgb(0, 0, 0)
              });
            }
          }
        });
      }

      // Emergency Contact
      secondPage.drawText(formData.section4?.emergencyContact?.name?.toUpperCase() || '', {
        x: 120,
        y: 192,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0),
        maxWidth: 120,
        lineHeight: 15
      });

      secondPage.drawText(formData.section4?.emergencyContact?.phone || '', {
        x: 255,
        y: 192,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0)
      });

      secondPage.drawText(formData.section4?.emergencyContact?.relationship?.toUpperCase() || '', {
        x: 410,
        y: 192,
        size: 7,
        font: helveticaFont,
        color: rgb(0, 0, 0)
      });

      page11.drawText(formData.section1?.personalInfo?.legalName?.toUpperCase() || '', {
        x: 95,
        y: 585,
        ...textOptions
      });

      if (formData.section4?.declaration?.date) {
        const decDate = moment(formData.section4.declaration.date);
        if (decDate.isValid()) {
          page11.drawText(decDate.format('DD-MM-YYYY'), {
            x: 120,
            y: 499,
            size: 9,
            font: helveticaFont,
            color: rgb(0, 0, 0)
          });
        }
      }

      page19.drawText(formData.section1?.personalInfo?.legalName?.toUpperCase() || '', {
        x: 95,
        y: 631,
        ...textOptions
      });

      page19.drawText(formData.section1?.personalInfo?.legalName?.toUpperCase() || '', {
        x: 170,
        y: 540,
        ...textOptions
      });

      if (formData.section6) {
        const joinDate = moment(formData.section6.signatureDate);
        if (joinDate.isValid()) {
          page19.drawText(joinDate.format('DD'), {
            x: 450,
            y: 565,
            ...textOptions
          });
          page19.drawText('/', {
            x: 460,
            y: 565,
            ...textOptions
          });
          page19.drawText(joinDate.format('MM'), {
            x: 465,
            y: 565,
            ...textOptions
          });
          page19.drawText('/', {
            x: 475,
            y: 565,
            ...textOptions
          });
          page19.drawText(joinDate.format('YYYY'), {
            x: 480,
            y: 565,
            ...textOptions
          });
        }
      }

      page19.drawText(formData.user_id?.toUpperCase() || '', {
        x: 475,
        y: 538,
        ...textOptions
      });

      page19.drawText(formData.section6?.place?.toUpperCase() || '', {
        x: 445,
        y: 510,
        ...textOptions
      });

      // Fixed: Changed ndaDesignation to designation
      page19.drawText(formData.section6?.designation?.toUpperCase() || '', {
        x: 150,
        y: 510,
        ...textOptions
      });

      if (formData.section5) {
        page20.drawText(formData.section5?.indemnityDay?.toUpperCase() || '', {
          x: 275,
          y: 671,
          ...textOptions
        });

        page20.drawText(formData.section5?.indemnityMonth?.toUpperCase() || '', {
          x: 340,
          y: 671,
          ...textOptions
        });

        page20.drawText(formData.section5?.indemnityYear?.toUpperCase() || '', {
          x: 415,
          y: 671,
          ...textOptions
        });

        page20.drawText(formData.section5?.indemnityName?.toUpperCase() || '', {
          x: 60,
          y: 660,
          ...textOptions
        });

        page20.drawText(formData.section5?.indemnityFatherName?.toUpperCase() || '', {
          x: 235,
          y: 660,
          ...textOptions
        });

        page20.drawText(formData.section1?.addressInfo?.permanentAddress?.pAddress?.toUpperCase() || '', {
          x: 440,
          y: 663,
          size: 5,
          font: helveticaFont,
          color: rgb(0, 0, 0)
        });

        page20.drawText(formData.section5?.aadhaarNumber?.toUpperCase() || '', {
          x: 145,
          y: 647,
          ...textOptions
        });

        page20.drawText(formData.section5?.witness1Name?.toUpperCase() || '', {
          x: 150,
          y: 134,
          ...textOptions
        });

        page20.drawText(formData.section5?.witness1Address?.toUpperCase() || '', {
          x: 150,
          y: 120,
          ...textOptions
        });

        page20.drawText(formData.section5?.witness2Name?.toUpperCase() || '', {
          x: 150,
          y: 89,
          ...textOptions
        });

        page20.drawText(formData.section5?.witness2Address?.toUpperCase() || '', {
          x: 150,
          y: 75,
          ...textOptions
        });

        page20.drawText(formData.section6?.ndaName?.toUpperCase() || '', {
          x: 60,
          y: 197,
          ...textOptions
        });

        page20.drawText(formData.section6?.ndaAddress?.toUpperCase() || '', {
          x: 60,
          y: 181,
          ...textOptions
        });
      }

      if (formData.section6) {
        page21.drawText(formData.section6?.ndaDay?.toUpperCase() || '', {
          x: 207,
          y: 645,
          ...textOptions
        });

        page21.drawText(formData.section6?.ndaMonth?.toUpperCase() || '', {
          x: 270,
          y: 645,
          ...textOptions
        });

        page21.drawText(formData.section6?.ndaYear?.toUpperCase() || '', {
          x: 330,
          y: 645,
          ...textOptions
        });

        page21.drawText(formData.section6?.ndaName?.toUpperCase() || '', {
          x: 124,
          y: 623,
          size: 7,
          font: helveticaFont,
          color: rgb(0, 0, 0)
        });

        page21.drawText(formData.section6?.ndaParentName?.toUpperCase() || '', {
          x: 240,
          y: 620,
          size: 7,
          font: helveticaFont,
          color: rgb(0, 0, 0)
        });

        page21.drawText(formData.section6?.ndaAddress?.toUpperCase() || '', {
          x: 224,
          y: 610,
          size: 7,
          font: helveticaFont,
          color: rgb(0, 0, 0)
        });

        page21.drawText(formData.section6?.aadhaarNumber?.toUpperCase() || '', {
          x: 60,
          y: 605,
          ...textOptions
        });
      }

      // Declaration Date
      if (formData.section4?.declaration?.date) {
        const decDate = moment(formData.section4.declaration.date);
        if (decDate.isValid()) {
          secondPage.drawText(decDate.format('DD-MM-YYYY'), {
            x: 400,
            y: 100,
            size: 9,
            font: helveticaFont,
            color: rgb(0, 0, 0)
          });
        }
      }

      page25.drawText(formData.section1?.personalInfo?.legalName?.toUpperCase() || '', {
        x: 65,
        y: 655,
        ...textOptions
      });

      page25.drawText(formData.section1?.personalInfo?.legalName?.toUpperCase() || '', {
        x: 170,
        y: 443,
        ...textOptions
      });

      if (formData.section1?.personalInfo?.joiningDate) {
        const joinDate = moment(formData.section6?.signatureDate);
        if (joinDate.isValid()) {
          page25.drawText(joinDate.format('DD'), {
            x: 90,
            y: 375,
            ...textOptions
          });
          page25.drawText('/', {
            x: 100,
            y: 375,
            ...textOptions
          });
          page25.drawText(joinDate.format('MM'), {
            x: 105,
            y: 375,
            ...textOptions
          });
          page25.drawText('/', {
            x: 115,
            y: 375,
            ...textOptions
          });
          page25.drawText(joinDate.format('YYYY'), {
            x: 120,
            y: 375,
            ...textOptions
          });
        }
      }

      page25.drawText(formData.section6?.place?.toUpperCase() || '', {
        x: 90,
        y: 341,
        ...textOptions
      });

      // Save the filled PDF
      const pdfBytes = await pdfDoc.save();
      return new Blob([pdfBytes], { type: 'application/pdf' });
    } catch (error) {
      console.error('Error filling PDF form:', error);
      throw error;
    }
  };

  const handlePreview = async () => {
    setLoadingPreview(true);
    try {
      const blob = await fillPdfForm();
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      setPreviewVisible(true);
    } catch (error) {
      console.error('Error generating preview:', error);
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleDownload = async () => {
    setLoadingDownload(true);
    try {
      const blob = await fillPdfForm();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Joining-Kit-${formData.user_id || 'unknown'}.pdf`;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }, 100);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    } finally {
      setLoadingDownload(false);
    }
  };

  return (
    <>
      <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          type="default"
          onClick={handlePreview}
          icon={loadingPreview ? <Spin /> : <FaEye />}
          disabled={loadingPreview}
        >
          {loadingPreview ? 'Generating PDF...' : 'Preview PDF'}
        </Button>
        <Button
          type="primary"
          onClick={handleDownload}
          icon={loadingDownload ? <Spin /> : <FaFileDownload />}
          disabled={loadingDownload || loadingPreview}
        >
          {loadingDownload ? 'Preparing Download...' : 'Download PDF'}
        </Button>
      </Space>

      <Modal
        title="Joining Kit Form Preview"
        open={previewVisible}
        onCancel={() => {
          setPreviewVisible(false);
          if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        }}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        destroyOnClose
      >
        {pdfUrl && (
          <iframe
            src={pdfUrl}
            width="100%"
            height="800px"
            style={{ border: 'none' }}
            title="Joining Kit PDF Preview"
          />
        )}
      </Modal>
    </>
  );
};

export default PdfJoiningKit;